/* DIYUK theme script: menu, search, rails, product options, cart drawer. No dependencies. */
(() => {
  const D = window.DIYUK || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* Money: Shopify format with {{amount}} style placeholders, amount in pence */
  const formatMoney = (pence) => {
    const fmt = D.money || '£{{amount}}';
    const value = (Math.round(pence) / 100);
    const two = value.toFixed(2);
    const withCommas = two.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(value).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/<[^>]*>/g, '');
  };
  /* Same rule as snippets/price-calc.liquid: one rounding at the end */
  const promoFactor = () => (D.promo && D.promo.mode !== 'none') ? (100 - Number(D.promo.percent || 0)) / 100 : 1;
  const finalPrice = (p) => Math.round(p * promoFactor());
  const exPrice = (p) => Math.round(p * promoFactor() / (1 + Number(D.vatRate || 20) / 100));

  /* Reveal on scroll */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px' }) : null;
  $$('.reveal').forEach((el) => io ? io.observe(el) : el.classList.add('is-in'));

  /* Mobile menu */
  const menu = $('#mobile-menu');
  const menuBtn = $('[data-menu-open]');
  const setMenu = (open) => {
    if (!menu) return;
    menu.dataset.open = String(open);
    if (menuBtn) menuBtn.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
  };
  menuBtn && menuBtn.addEventListener('click', () => setMenu(true));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => setMenu(false)));

  /* Search overlay with predictive search (Section Rendering API) */
  const panel = $('[data-search-panel]');
  const input = $('[data-search-input]');
  const results = $('[data-search-results]');
  let searchAbort;
  const setSearch = (open) => {
    if (!panel) return;
    panel.dataset.open = String(open);
    $$('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) setTimeout(() => input && input.focus(), 30);
  };
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', () => setSearch(true)));
  $$('[data-search-close]').forEach((b) => b.addEventListener('click', () => setSearch(false)));
  /* Predictive results for the header panel and the inline boxes. A bare standard number (e.g. 3017) is also
     looked up as DIN<number>, because some products carry the norm only as DIN3017 in their SKUs
     (user 12.10.2026 22:25:25 BST: "wyszukujac 3017 nic nie pokazuje i musze wpisac din3017"). */
  const bareNumber = (q) => /^\d{2,5}$/.test(q);
  const suggestOne = async (q, signal) => {
    const url = `${D.routes.suggest}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
    const res = await fetch(url, { signal });
    return new DOMParser().parseFromString(await res.text(), 'text/html').querySelector('[data-predictive-results]');
  };
  const suggest = async (q, signal) => {
    if (!bareNumber(q)) return suggestOne(q, signal);
    const [main, alt] = await Promise.all([suggestOne(q, signal), suggestOne('DIN' + q, signal)]);
    const items = (el) => (el ? [...el.querySelectorAll('.predictive__list[role="listbox"] > li')] : []);
    const altItems = items(alt);
    if (!altItems.length) return main;
    const mainList = main && main.querySelector('.predictive__list[role="listbox"]');
    if (!mainList) return alt;
    const seen = new Set(items(main).map((li) => li.querySelector('a').getAttribute('href')));
    altItems.forEach((li) => { if (!seen.has(li.querySelector('a').getAttribute('href'))) mainList.append(li); });
    return main;
  };
  let searchTimer;
  input && input.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = input.value.trim();
    if (!q) { results.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      if (searchAbort) searchAbort.abort();
      searchAbort = new AbortController();
      try {
        const found = await suggest(q, searchAbort.signal);
        results.innerHTML = found ? found.outerHTML : '';
      } catch (e) { if (e.name !== 'AbortError') results.innerHTML = ''; }
    }, 180);
  });

  /* Inline search boxes (home page) with the same predictive results */
  /* Home: the header search box hides while the big search box in the hero is on screen */
  const heroSearch = $('[data-inline-search]');
  if (heroSearch && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      document.body.classList.toggle('hero-search-on', entry.isIntersecting);
    }, { rootMargin: '-110px 0px 0px 0px' }).observe(heroSearch);
  }

  $$('[data-inline-search]').forEach((form) => {
    const field = $('[data-inline-search-input]', form);
    const box = $('[data-inline-search-results]', form);
    if (!field || !box) return;
    let timer, ctrl;
    const hide = () => { box.hidden = true; };
    field.addEventListener('input', () => {
      clearTimeout(timer);
      const q = field.value.trim();
      if (!q) { box.innerHTML = ''; hide(); return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const found = await suggest(q, ctrl.signal);
          box.innerHTML = found ? found.outerHTML : '';
          box.hidden = !found;
        } catch (e) { if (e.name !== 'AbortError') { box.innerHTML = ''; hide(); } }
      }, 180);
    });
    field.addEventListener('focus', () => { if (box.innerHTML.trim()) box.hidden = false; });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) hide(); });
    form.addEventListener('keydown', (e) => { if (e.key === 'Escape') { hide(); field.blur(); } });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    setSearch(false); setMenu(false); setCart(false);
  });

  /* Search page: no results for a bare standard number, so show the results for DIN<number> (3017 -> DIN3017) */
  const searchPage = $('[data-search-page]');
  if (searchPage) {
    const params = new URLSearchParams(location.search);
    const q = (params.get('q') || '').trim();
    const from = (params.get('from') || '').trim();
    if (searchPage.dataset.count === '0' && bareNumber(q) && !from) {
      params.set('q', 'DIN' + q);
      params.set('from', q);
      location.replace(`${location.pathname}?${params.toString()}`);
    } else if (from && bareNumber(from)) {
      const note = $('[data-search-from]', searchPage);
      if (note) { note.textContent = note.dataset.text.replace('%q', from); note.hidden = false; }
    }
  }

  /* "Shop by product" tiles: loaded when the row comes near the screen (speed, 12.10.2026) */
  $$('[data-kinds-src]').forEach((rail) => {
    const load = () => fetch(rail.dataset.kindsSrc).then((r) => (r.ok ? r.text() : Promise.reject(r.status))).then((html) => {
      const items = new DOMParser().parseFromString(html, 'text/html').querySelector('.kind-rail-items');
      if (items && items.children.length) { rail.innerHTML = items.innerHTML; rail.scrollLeft = 0; }
    }).catch(() => {});
    if (!('IntersectionObserver' in window)) { load(); return; }
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      load();
    }, { rootMargin: '800px 0px' });
    io.observe(rail);
  });

  /* Rails: arrow buttons */
  $$('[data-rail-controls]').forEach((ctrl) => {
    const rail = ctrl.closest('.wrap') && ctrl.closest('.wrap').querySelector('[data-rail]');
    if (!rail) return;
    const step = () => rail.clientWidth * 0.8;
    $('[data-rail-prev]', ctrl).addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('[data-rail-next]', ctrl).addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* Category buttons: bring the current category into view on phones */
  $$('.chips-nav').forEach((nav) => {
    const cur = $('[aria-current="page"]', nav);
    if (cur && nav.scrollWidth > nav.clientWidth) nav.scrollLeft = cur.offsetLeft - nav.offsetLeft - 16;
  });

  /* Product kinds inside a category: show one kind, keep it in the address as #typ=<slug> (R3 a, 12.10.2026) */
  $$('[data-kind-chips]').forEach((group) => {
    const scope = group.closest('.wrap') || document;
    const cards = $$('.grid [data-typ]', scope);
    const counter = $('[data-kind-count]', scope);
    const chips = $$('[data-kind]', group);
    const known = new Set();
    chips.forEach((chip) => {
      const kind = chip.dataset.kind;
      if (!kind) return;
      const n = cards.filter((c) => c.dataset.typ === kind).length;
      if (!n) { chip.hidden = true; return; }
      known.add(kind);
      const badge = $('[data-kind-n]', chip);
      if (badge) badge.textContent = n;
    });
    if (known.size < 2) { group.hidden = true; return; }
    const show = (kind, write) => {
      if (!known.has(kind)) kind = '';
      chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.kind === kind)));
      let n = 0;
      cards.forEach((card) => {
        const on = !kind || card.dataset.typ === kind;
        card.hidden = !on;
        if (on) n += 1;
      });
      if (counter && counter.dataset.other) counter.textContent = n === 1 ? counter.dataset.one : counter.dataset.other.replace('%n', n);
      if (write) history.replaceState(null, '', kind ? '#typ=' + kind : location.pathname + location.search);
    };
    group.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-kind]');
      if (chip) show(chip.dataset.kind, true);
    });
    const fromHash = () => {
      const m = location.hash.match(/^#typ=([a-z0-9-]+)$/);
      show(m ? m[1] : '', false);
    };
    window.addEventListener('hashchange', fromHash);
    fromHash();
  });

  /* Cart drawer */
  const drawerSel = '[data-cart-drawer]';
  const setCart = (open) => {
    const drawer = $(drawerSel);
    if (!drawer) return;
    drawer.dataset.open = String(open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  };
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && $(drawerSel) && document.body.dataset.template !== 'cart') { e.preventDefault(); setCart(true); return; }
    if (e.target.closest('[data-cart-close]')) setCart(false);
  });
  const updateCount = (count) => $$('[data-cart-count]').forEach((el) => { el.textContent = count > 0 ? count : ''; el.dataset.count = count; });
  const renderDrawer = (sections) => {
    if (!sections || !sections['cart-drawer']) return;
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('[data-cart-panel]');
    const panelEl = $('[data-cart-panel]');
    if (fresh && panelEl) panelEl.innerHTML = fresh.innerHTML;
  };
  /* Project calculators add many lines at once (assets/calculator.js) */
  document.addEventListener('diyuk:cart-updated', (e) => {
    const d = e.detail || {};
    renderDrawer(d.sections);
    if (typeof d.count === 'number') updateCount(d.count);
    if (d.open !== false) setCart(true);
  });
  const changeLine = async (line, quantity) => {
    const body = JSON.stringify({ line, quantity, sections: 'cart-drawer' });
    const res = await fetch(`${D.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body });
    const cart = await res.json();
    if (document.body.dataset.template === 'cart') { window.location.reload(); return; }
    updateCount(cart.item_count);
    renderDrawer(cart.sections);
  };
  document.addEventListener('click', (e) => {
    const lineEl = e.target.closest('[data-line]');
    if (!lineEl) return;
    const line = Number(lineEl.dataset.line);
    const qtyInput = $('[data-line-input]', lineEl);
    const change = e.target.closest('[data-line-change]');
    if (change) { changeLine(line, Math.max(0, Number(qtyInput.value) + Number(change.dataset.lineChange))); }
    if (e.target.closest('[data-line-remove]')) changeLine(line, 0);
  });
  document.addEventListener('change', (e) => {
    const inputEl = e.target.closest('[data-line-input]');
    if (!inputEl) return;
    const lineEl = inputEl.closest('[data-line]');
    changeLine(Number(lineEl.dataset.line), Math.max(0, Number(inputEl.value) || 0));
  });

  /* Collection: auto submit sort and filters */
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-autosubmit]')) {
      const form = e.target.form;
      if (!form) return;
      const params = new URLSearchParams(window.location.search);
      const data = new FormData(form);
      // keep params owned by the other form
      $$('[data-collection-form]').forEach((f) => { if (f !== form) new FormData(f).forEach((v, k) => { if (!data.has(k)) data.append(k, v); }); });
      const next = new URLSearchParams();
      data.forEach((v, k) => next.append(k, v));
      if (params.get('q') && !next.get('q')) next.set('q', params.get('q'));
      window.location.search = next.toString();
    }
  });

  /* Product page */
  const form = $('#product-form');
  const dataEl = $('[data-product-json]');
  if (form && dataEl) {
    const { variants } = JSON.parse(dataEl.textContent);
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add]', form);
    const stock = $('[data-stock]', form);
    const errorEl = $('[data-form-error]', form);
    const fieldsets = $$('fieldset[data-option-index]', form);
    const priceBlock = $('#price-main');
    const qty = $('[data-qty] input', form);
    const stickyBar = $('[data-sticky-buy]');
    const stickyPrice = $('[data-sticky-price]');
    /* Plan "k21 bar" (03.11.2026, PR-613): the sticky button copies the state and words of the main button */
    const stickyAdd = stickyBar ? $('[data-sticky-add]', stickyBar) : null;
    const syncSticky = () => { if (stickyAdd) { stickyAdd.disabled = addBtn.disabled; stickyAdd.textContent = addBtn.textContent; } };

    const selected = () => fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));
    const packIndex = fieldsets.findIndex((fs) => /pack|quantity/i.test(($('legend', fs) || {}).textContent || ''));

    /* Per-piece price on pack chips, and the lowest per-piece badge, for the current other options */
    const paintChips = () => {
      if (packIndex < 0) return;
      const opts = selected();
      const chips = $$('[data-chip]', fieldsets[packIndex]);
      let best = null;
      const per = chips.map((chip) => {
        const value = $('input', chip).value;
        const trial = opts.slice(); trial[packIndex] = value;
        const v = findVariant(trial);
        const unitEl = $('[data-chip-unit]', chip);
        if (!v || !v.pack || v.pack < 1) { if (unitEl) unitEl.textContent = ''; return null; }
        const p = finalPrice(v.price) / v.pack;
        if (unitEl) unitEl.textContent = (D.strings.perPiece || '[price] each').replace('[price]', formatMoney(p)).replace(/<[^>]*>/g, '');
        if (v.available && (best === null || p < best.p)) best = { p, chip };
        return p;
      });
      chips.forEach((chip) => { const b = $('[data-chip-best]', chip); if (b) b.hidden = true; });
      const priced = per.filter((x) => x !== null);
      if (best && priced.length > 1 && Math.max(...priced) > best.p) { const b = $('[data-chip-best]', best.chip); if (b) b.hidden = false; }
    };

    /* Availability of each value given the other selected options */
    const paintAvailability = () => {
      const opts = selected();
      fieldsets.forEach((fs, i) => {
        $$('[data-chip]', fs).forEach((chip) => {
          const trial = opts.slice(); trial[i] = $('input', chip).value;
          const v = findVariant(trial);
          chip.dataset.unavailable = String(!v || !v.available);
        });
      });
    };

    const update = (push = true) => {
      const opts = selected();
      fieldsets.forEach((fs, i) => { const s = $('[data-option-selected]', fs); if (s) s.textContent = opts[i] || ''; });
      const v = findVariant(opts);
      paintAvailability();
      paintChips();
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = D.strings.unavailable;
        stock.dataset.state = 'out'; stock.textContent = D.strings.unavailable;
        syncSticky();
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? D.strings.addToCart : D.strings.soldOut;
      stock.dataset.state = v.available ? 'in' : 'out';
      stock.textContent = v.available ? D.strings.inStock : D.strings.soldOut;
      syncSticky();
      if (priceBlock) {
        const f = finalPrice(v.price);
        const main = $('[data-price-final]', priceBlock); if (main) main.textContent = formatMoney(f);
        const was = $('[data-price-was]', priceBlock); if (was) was.lastChild.textContent = formatMoney(v.price);
        const ex = $('[data-price-ex]', priceBlock); if (ex) ex.textContent = formatMoney(exPrice(v.price));
        let unit = $('[data-price-unit]', priceBlock);
        if (v.pack > 1) {
          if (!unit) { unit = document.createElement('span'); unit.className = 'price__ex'; unit.setAttribute('data-price-unit', ''); priceBlock.appendChild(unit); }
          unit.textContent = (D.strings.perPiece || '[price] each').replace('[price]', formatMoney(f / v.pack)).replace(/<[^>]*>/g, '');
        } else if (unit) { unit.remove(); }
        if (stickyPrice) stickyPrice.textContent = formatMoney(f);
      }
      $$('[data-variant-row]').forEach((row) => { row.dataset.current = String(row.dataset.variantRow === String(v.id)); });
      if (v.media) {
        const slide = $(`[data-media-id="${v.media}"]`);
        const main = $('[data-gallery-main]');
        if (slide && main) main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      if (push) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    };
    form.addEventListener('change', (e) => { if (e.target.matches('fieldset[data-option-index] input')) update(); });

    /* Select a variant from the price table */
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-select-variant]');
      if (!btn) return;
      const v = variants.find((x) => String(x.id) === btn.dataset.selectVariant);
      if (!v) return;
      fieldsets.forEach((fs, i) => { $$('input', fs).forEach((inp) => { inp.checked = inp.value === v.options[i]; }); });
      update();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    /* Quantity stepper */
    $('[data-qty-minus]', form).addEventListener('click', () => { qty.value = Math.max(1, (Number(qty.value) || 1) - 1); });
    $('[data-qty-plus]', form).addEventListener('click', () => { qty.value = (Number(qty.value) || 1) + 1; });

    /* Add to cart via Ajax API, then open the drawer */
    form.addEventListener('submit', async (e) => {
      if (!$(drawerSel)) return;
      e.preventDefault();
      errorEl.hidden = true;
      addBtn.setAttribute('aria-busy', 'true');
      try {
        const body = JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(qty.value) || 1 }], sections: 'cart-drawer' });
        const res = await fetch(`${D.routes.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || D.strings.error);
        renderDrawer(data.sections);
        const cartRes = await fetch(`${D.routes.cart}.js`);
        const cart = await cartRes.json();
        updateCount(cart.item_count);
        setCart(true);
      } catch (err) {
        errorEl.textContent = err.message || D.strings.error;
        errorEl.hidden = false;
      } finally {
        addBtn.removeAttribute('aria-busy');
      }
    });

    /* Gallery thumbnails */
    const main = $('[data-gallery-main]');
    const thumbs = $$('[data-thumb]');
    const thumbRow = $('[data-gallery-thumbs]');
    const current = $('[data-gallery-current]');
    const slideIndex = () => (main ? Math.round(main.scrollLeft / main.clientWidth) : 0);
    let target = null; let targetTimer;
    const goTo = (i) => {
      if (!main || !main.children.length) return;
      const n = main.children.length;
      target = ((i % n) + n) % n;
      clearTimeout(targetTimer);
      targetTimer = setTimeout(() => { target = null; }, 2000);
      main.scrollTo({ left: main.children[target].offsetLeft, behavior: 'smooth' });
    };
    const currentIndex = () => (target !== null ? target : slideIndex());
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
    const prevBtn = $('[data-gallery-prev]');
    const nextBtn = $('[data-gallery-next]');
    prevBtn && prevBtn.addEventListener('click', () => goTo(currentIndex() - 1));
    nextBtn && nextBtn.addEventListener('click', () => goTo(currentIndex() + 1));
    main && main.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex() - 1); }
    });
    main && main.addEventListener('scroll', () => {
      const i = slideIndex();
      if (i === target) target = null;
      thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
      if (current) current.textContent = String(i + 1);
      const active = thumbs[i];
      if (active && thumbRow) {
        const left = active.offsetLeft - thumbRow.offsetLeft;
        if (left < thumbRow.scrollLeft || left + active.offsetWidth > thumbRow.scrollLeft + thumbRow.clientWidth) {
          thumbRow.scrollTo({ left: left - (thumbRow.clientWidth - active.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
    }, { passive: true });
    main && main.addEventListener('scrollend', () => { target = null; });

    /* Photo zoom: full-screen viewer, click or tap a photo to zoom in and pan (user 12.10.2026 21:52:34) */
    const box = $('[data-lightbox]');
    if (box && typeof box.showModal === 'function') {
      const track = $('[data-lightbox-track]', box);
      const slides = $$('[data-lightbox-slide]', box);
      const boxCurrent = $('[data-lightbox-current]', box);
      let boxAt = 0;
      let boxTarget = null; let boxTimer;
      const boxIndex = () => (boxTarget !== null ? boxTarget : boxAt);
      const unzoom = () => {
        slides.forEach((sl) => { if (!sl.classList.contains('is-zoomed')) return; sl.classList.remove('is-zoomed'); const im = $('img', sl); im.style.width = ''; im.style.height = ''; });
        track.classList.remove('is-zoomed');
      };
      const boxGo = (i, smooth = true) => {
        const n = slides.length;
        const k = ((i % n) + n) % n;
        unzoom();
        boxAt = k;
        boxTarget = smooth ? k : null;
        clearTimeout(boxTimer);
        boxTimer = setTimeout(() => { boxTarget = null; }, 2000);
        track.scrollTo({ left: slides[k].offsetLeft, behavior: smooth ? 'smooth' : 'instant' });
        if (boxCurrent) boxCurrent.textContent = String(k + 1);
      };
      const open = (i) => {
        box.showModal();
        boxGo(i, false);
      };
      $$('[data-lightbox-open]').forEach((b) => b.addEventListener('click', () => open(slideIndex())));
      main && main.addEventListener('click', (e) => {
        const slide = e.target.closest('.gallery__slide');
        if (slide) open(Array.prototype.indexOf.call(main.children, slide));
      });
      $('[data-lightbox-close]', box).addEventListener('click', () => box.close());
      const lbPrev = $('[data-lightbox-prev]', box);
      const lbNext = $('[data-lightbox-next]', box);
      lbPrev && lbPrev.addEventListener('click', () => boxGo(boxIndex() - 1));
      lbNext && lbNext.addEventListener('click', () => boxGo(boxIndex() + 1));
      box.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); boxGo(boxIndex() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); boxGo(boxIndex() - 1); }
      });
      track.addEventListener('scroll', () => {
        if (!box.open || !track.clientWidth) return;
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i === boxTarget) boxTarget = null;
        if (boxTarget === null) boxAt = i;
        if (boxCurrent) boxCurrent.textContent = String((boxTarget !== null ? boxTarget : i) + 1);
      }, { passive: true });
      track.addEventListener('scrollend', () => { boxTarget = null; });
      box.addEventListener('close', () => {
        const i = boxAt;
        unzoom();
        if (main && main.children[i]) main.scrollTo({ left: main.children[i].offsetLeft, behavior: 'instant' });
      });
      slides.forEach((slide) => {
        const img = $('img', slide);
        img.addEventListener('click', (e) => {
          if (slide.classList.contains('is-zoomed')) { unzoom(); return; }
          const r = img.getBoundingClientRect();
          const fx = (e.clientX - r.left) / r.width;
          const fy = (e.clientY - r.top) / r.height;
          const w = r.width * 2.5;
          const h = r.height * 2.5;
          const sr = slide.getBoundingClientRect();
          if (img.dataset.full && img.getAttribute('srcset')) { img.removeAttribute('srcset'); img.src = img.dataset.full; }
          track.classList.add('is-zoomed');
          slide.classList.add('is-zoomed');
          img.style.width = `${w}px`;
          img.style.height = `${h}px`;
          slide.scrollLeft = fx * w - (e.clientX - sr.left);
          slide.scrollTop = fy * h - (e.clientY - sr.top);
        });
        slide.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse' || !slide.classList.contains('is-zoomed')) return;
          const sr = slide.getBoundingClientRect();
          slide.scrollLeft = ((e.clientX - sr.left) / sr.width) * (slide.scrollWidth - slide.clientWidth);
          slide.scrollTop = ((e.clientY - sr.top) / sr.height) * (slide.scrollHeight - slide.clientHeight);
        });
      });
    }

    /* Sticky buy bar when the main button leaves the screen */
    if (stickyBar && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.dataset.show = String(show);
        stickyBar.setAttribute('aria-hidden', String(!show));
        $('[data-sticky-add]', stickyBar).tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      stickyAdd.addEventListener('click', () => { if (addBtn.disabled) return; form.requestSubmit ? form.requestSubmit() : addBtn.click(); });
    }

    update(false);
  }

  /* Collection filters on phones and tablets: one button shows and hides them (plan O4, 16.10.2026) */
  $$('[data-filters-toggle]').forEach((btn) => {
    const box = document.getElementById(btn.getAttribute('aria-controls'));
    if (!box) return;
    btn.addEventListener('click', () => {
      const open = box.dataset.open !== 'true';
      box.dataset.open = String(open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* Product description on phones and tablets: each heading (h2-h4, or a paragraph that is only bold text, up to 80
     characters) starts a section that opens on tap; the text before the first heading stays as it is. Nothing is
     removed: the heading text becomes the section title. Computers keep the full text (plan O3, 16.10.2026). */
  if (!window.matchMedia('(min-width: 1068px)').matches) {
    const isHead = (el) => {
      if (el.nodeType !== 1) return false;
      if (/^H[2-4]$/.test(el.tagName)) return true;
      const t = el.textContent.trim();
      return el.tagName === 'P' && el.children.length === 1 && /^(STRONG|B)$/.test(el.children[0].tagName)
        && t === el.children[0].textContent.trim() && t.length > 0 && t.length <= 80;
    };
    $$('[data-desc-sections]').forEach((body) => {
      const nodes = Array.from(body.childNodes);
      const heads = nodes.filter(isHead);
      if (heads.length < 2) return;
      const intro = nodes.slice(0, nodes.indexOf(heads[0])).some((n) => n.nodeType === 1 || n.textContent.trim());
      let inner = null;
      nodes.forEach((n) => {
        if (isHead(n)) {
          const sec = document.createElement('details');
          sec.className = 'acc acc--sub';
          if (!intro && n === heads[0]) sec.open = true;
          const sum = document.createElement('summary');
          sum.textContent = n.textContent.trim();
          inner = document.createElement('div');
          inner.className = 'acc__body';
          sec.append(sum, inner);
          n.replaceWith(sec);
        } else if (inner) {
          inner.append(n);
        }
      });
      body.classList.add('rte--sections');
    });
  }

  /* Product sections: expanded on desktop, collapsed on phones (Baymard, horizontal tabs study 08.07.2026) */
  if (window.matchMedia('(min-width: 1068px)').matches) {
    $$('details[data-desktop-open]').forEach((d) => { d.open = true; });
  }

  /* Related products: load by Section Rendering API */
  const rec = $('[data-recommendations]');
  if (rec && rec.dataset.url && !rec.querySelector('.rail')) {
    fetch(rec.dataset.url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) rec.innerHTML = fresh.innerHTML; else rec.remove();
    }).catch(() => rec.remove());
  }
})();
